import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getCellStyles } from '../TableBody/hooks/getCellStyles'

export const HeadRow = styled.tr`
  padding: ${Spacing.S12} ${Spacing.S16};
  background-color: ${Color.Black};
`

export const HeadCell = styled.th`
  ${getCellStyles()}
`
